import { render, staticRenderFns } from "./Workplaces.vue?vue&type=template&id=6f7d69bf"
import script from "./Workplaces.vue?vue&type=script&lang=ts"
export * from "./Workplaces.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports